import axios from "axios";
import { APP_VERSION } from "../store/constants.js";

// export const BASE_URL = "http://localhost:5001";
export const BASE_URL = process.env.REACT_APP_API_URL || "https://mrc.potentium.rs";

const API_BASE_URL = `${BASE_URL}/api/`;
const AUTH_BASE_URL = `${BASE_URL}/auth/`;

const axiosAuthClient = axios.create({
  baseURL: AUTH_BASE_URL,
  withCredentials: true,
});

const axiosApiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Public client for unauthenticated requests
const axiosPublicClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
});

axiosAuthClient.interceptors.request.use(
  (config) => {
    config.headers = {
      version: APP_VERSION,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

let store;
export const injectStore = (_store) => {
  store = _store;
};

axiosApiClient.interceptors.request.use(
  (config) => {
    const token = store.getState().authInfo.token;
    config.headers = {
      version: APP_VERSION,
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    };

    // Samo dodaj Authorization header ako token postoji
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Dodaj Content-Type header za JSON requests ako nije FormData
    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json; charset=utf-8";
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor - handles 401 with automatic token refresh
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

axiosApiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return axiosApiClient(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const response = await axiosAuthClient.get("/refresh-token");
        const { accessToken } = response.data.data;

        store.dispatch({
          type: "authInfo/setToken",
          payload: accessToken,
        });

        processQueue(null, accessToken);

        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return axiosApiClient(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);

        store.dispatch({
          type: "authInfo/setLoggedIn",
          payload: { loggedIn: false },
        });

        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  },
);

// Public client interceptor (no auth)
axiosPublicClient.interceptors.request.use(
  (config) => {
    config.headers = {
      version: APP_VERSION,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default axiosApiClient;
export { axiosAuthClient, axiosApiClient, axiosPublicClient };
